
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../../../../assets/css/user/home/subscreens/benefits/BeneFit.css';
import benefitImg from '../../../../assets/images/home/benefit.jpg';
const BeneFits= () => {
  const features = [
    {
      id: 1,
      title: 'Rental Services',
      description: 'Flexible rental of tractors and farming equipment to ensure timely field operations without high ownership costs.'
    },
    {
      id: 2,
      title: 'Maintenance Services',
      description: 'Quick and reliable repair services by skilled technicians to minimize downtime and keep equipment running efficiently.'
    }
  ];

  return (
    <section className="welcome-section">
      <Container>
        <Row className="align-items-center">
          {/* Left Content Column */}
          <Col lg={6} md={12} className="content-column">
            <div className="welcome-content">
              <p className="welcome-label">SOME FEATURES AND</p>
              <h2 className="welcome-heading">BENEFIT SMARTAGRIRENT</h2>
              
              <p className="welcome-description">
                SmartAgriRent is designed to support modern farmers by providing easy access to agricultural machinery and reliable maintenance services. We aim to reduce delays in farming operations by offering timely equipment rental and on-demand repair solutions, ensuring that farmers can focus on productivity without worrying about equipment availability.
              </p>

              <p className="welcome-description">
                Our platform connects users with well-maintained machinery and skilled mechanics, helping to minimize crop loss during critical seasons. By combining technology with agriculture, we create a system that improves efficiency, saves time, and supports sustainable farming practices.
              </p>

              {/* Features Grid */}
              <Row className="features-row">
                {features.map((feature) => (
                  <Col key={feature.id} md={6} sm={12} className="feature-col">
                    <div className="feature-item">
                      <h4 className="feature-title">{feature.title}</h4>
                      <p className="feature-description">{feature.description}</p>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>

          {/* Right Image Column */}
          <Col lg={6} md={12} className="image-column">
            <div className="image-wrapper">
              <div className="image-border-top"></div>
              <div className="image-border-bottom"></div>
              <img
                src={benefitImg}
                alt="Equipment Repair"
                className="welcome-image"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default BeneFits;